import { z } from "zod";

/** 统计周期，变化值按等长的上一周期算（GON-11）。 */
export const periodSchema = z.enum(["last_7_days", "last_30_days"]);

export type Period = z.infer<typeof periodSchema>;

/** 带时区偏移的 ISO 时间串，后台按工作区时区再格式化。 */
export const isoDateTimeSchema = z.iso.datetime({ offset: true });

/** 金额用字符串传，避免浮点误差；币种为 ISO 4217 三字码。 */
export const moneySchema = z.object({
  amount: z.string().regex(/^\d+(?:\.\d{1,2})?$/),
  currency: z.string().length(3),
});

export type Money = z.infer<typeof moneySchema>;

/** 游标分页的查询参数；`cursor` 缺省表示第一页。 */
export const pageQuerySchema = z.object({
  cursor: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});

export type PageQuery = z.infer<typeof pageQuerySchema>;

/** 游标分页的响应：`nextCursor` 为 null 表示已到末页。 */
export function pageSchema<TItem extends z.ZodType>(item: TItem) {
  return z.object({
    items: z.array(item),
    nextCursor: z.string().min(1).nullable(),
  });
}
